import type { FaireProductEntity } from "../../entity_types/product";

export const p_2dv9e2uwhc: FaireProductEntity = {
  token: "p_2dv9e2uwhc",
  type: "product",
  name: "29 PALMS REED DIFFUSER",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/8fc3b4074f4f4d6e9a200becc29da01cdb7f0b2853b237b8a154f11719434e6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e83ca5e0511b15a6129dd59e1a5c0dff663d07b78d8887925d49c315191bdaf.jpeg",
    "https://cdn.faire.com/fastly/061c08f5a49318494635a13ccf0a9bc14c063ba1ef9e0ff80466a65afc93b4ed.jpeg"
  ],
  priceDollars: 19,
  description: "Introducing our new reed diffusers! Fill your space with your favorite ROEN scent without the flame.\n\nCapturing the essence of the cool morning desert air after rainfall. Pure and simple in nature, this scent opens with the soothing fragrance of eucalyptus and desert sage atop woody base notes of cedar and palo santo and finished with the delicate nuance of rain accord.\n\nDesert sage, cedar, eucalyptus, palo santo, white musk\n\nRoen is hand poured in our Southern California studio. All of our products are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n3 fl oz (88 ml), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:11.484Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
